import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-vendor-products',
  templateUrl: './vendor-products.component.html',
  styleUrls: ['./vendor-products.component.scss'],
})
export class VendorProductsComponent implements OnInit {
  public links = [
    { title: 'Stripe Products', link: '/vendor-products/stripe-products' },
    { title: 'Vendor Products', link: '/vendor-products/vendor-products' },
    { title: 'User Vendor Products', link: '/vendor-products/user-vendor-products' },
    { title: 'Vendor Webhook Events', link: '/vendor-products/vendor-webhooks' },
    { title: 'Vendor API Log', link: '/vendor-products/vendor-api-log' },
    { title: 'Vendor Pending Transfers', link: '/vendor-products/vendor-pending-transfers' },
    { title: 'Vendor Completed Transfers', link: '/vendor-products/vendor-completed-transfers' },
  ];
  public activeLink = this.links[0];

  constructor(private readonly router: Router) {}

  ngOnInit(): void {
    const parsedUrl = this.router.parseUrl(this.router.url);
    const url = parsedUrl.toString().split('?')[0];
    this.activeLink = this.links.find((link) => link.link === url) || this.links[0];
  }

  gotoTab(link: { title: string; link: string }): void {
    this.router.navigate([link.link]);
    this.activeLink = link;
  }
}
